import { render, staticRenderFns } from "./pre_date_year.vue?vue&type=template&id=a831c0f2"
import script from "./pre_date_year.vue?vue&type=script&lang=js"
export * from "./pre_date_year.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports